import { useTheme } from '../useTheme';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BreezeGradients = () => {
  const {
    breezeColors
  } = useTheme();
  const {
    primary,
    secondary
  } = breezeColors;
  const darkStop1 = '#fc0849';
  const mediumStop1 = '#fb31a7';
  return /*#__PURE__*/_jsxs("svg", {
    fill: "none",
    height: "0",
    opacity: "0",
    style: {
      position: 'absolute'
    },
    width: "0",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsxs("linearGradient", {
      id: "breeze-intelligence-kit-gradient-dark",
      x1: "0",
      x2: "1",
      y1: "0",
      y2: "1",
      children: [/*#__PURE__*/_jsx("stop", {
        offset: "0",
        stopColor: darkStop1
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: primary.default
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      gradientTransform: "rotate(99)",
      id: "breeze-intelligence-kit-gradient-light",
      x1: "0",
      x2: "1",
      y1: "0",
      y2: "1",
      children: [/*#__PURE__*/_jsx("stop", {
        offset: "0",
        stopColor: secondary['2xLight']
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: primary.light
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "breeze-intelligence-kit-gradient-medium",
      x1: "0",
      x2: "1",
      y1: "0",
      y2: "1",
      children: [/*#__PURE__*/_jsx("stop", {
        offset: "0",
        stopColor: mediumStop1
      }), /*#__PURE__*/_jsx("stop", {
        offset: ".35",
        stopColor: secondary.light
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: secondary['2xLight']
      })]
    })]
  });
};